module.exports = require('./MessengerAlertSuccessView');
